module.exports = require('./MessengerAlertSuccessView');
